import React, { MouseEvent, PropsWithChildren } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import CopyIcon from '@mui/icons-material/ContentCopy';
import { UtilOnHoverWrapper } from '@/components/utilOnHoverWrapper';
import { ClipboardHelper } from '@/util';

export type CopyButtonProps = Omit<
  IconButtonProps<any>,
  'onClick' | 'onCopy' | 'children'
> & {
  onCopy?: (e: MouseEvent<HTMLButtonElement>) => Promise<boolean>;
};

export const CopyButton = ({ onCopy, ...props }: CopyButtonProps) => (
  <IconButton
    sx={{ background: 'transparent!important' }}
    size="small"
    {...props}
    onClick={onCopy}
  >
    <CopyIcon
      sx={{ width: 20, height: 20, opacity: 0.85, '&:hover': { opacity: 1 } }}
    />
  </IconButton>
);

export const CopyButtonOnHoverWrapper = ({
  children,
  ...props
}: PropsWithChildren<CopyButtonProps>) =>
  ClipboardHelper.isAvailable ? (
    <UtilOnHoverWrapper utility={<CopyButton {...props} />}>
      {children}
    </UtilOnHoverWrapper>
  ) : (
    <>{children}</>
  );
